import { useEffect, useState } from "react";
import styled from "styled-components";
import axios from "axios";
import { useHistory } from "react-router";
import { useSelector } from "react-redux";
import styles from "../login/login.module.css";



const Container = styled.div`
padding: 15px;
width: 80%;
height: 565px;
margin: 39px auto;
background-color: white;
border-radius: 15px;
box-shadow: rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px, rgba(17, 17, 26, 0.1) 0px 24px 80px;
h2 {
    font-size: 30px;
    text-align: center;
}
`;
const HeadDiv = styled.div`
margin: 10px auto;
width: 70%;
`;
const FormDiv = styled.div`
width: 70%;
display: flex;
flex-direction: column;
margin: auto;
div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 5px;
    input {
        width: 50%;
        height: 39px;
    }
}
`;


export function Signup() {
    const token = useSelector(state => state.token);
    const loggedIn = useSelector(state => state.loggedIn);
    const history = useHistory();
    const [data, setData] = useState("");
    const url = process.env.REACT_APP_url;
    console.log(url);


    useEffect(() => {
        if (loggedIn) {
            history.push("/homepage");
        }
    })
    

    const handleChange = (e) => {
        const { name, value } = e.target;
        setData({ ...data, [name]: value });
    }
    
    const handleSignup = (e) => {
        e.preventDefault();
        const config = {
            method: "post",
            data: data,
            url: `${url}/signup`
        };
        axios(config)
            .then((data) => {
                // console.log(data);
                history.push("/login");
            })
            .catch((err) => {
                alert(err);
            })
        // console.log(data);
    }
    return (
        <div className={styles.outerDiv}>
            <div className={styles.logoDiv}>
                <img style={{cursor:"pointer"}} onClick={() => history.push("/")} src="https://hash-node.vercel.app/static/media/hashnode.76db81e9.svg" alt="hashnode_logo"/>
            </div>
        <Container>
                <h2>Create your account</h2>
                <form onSubmit={handleSignup}>
                    <FormDiv>
                        <div>
                            <p>Full Name</p>
                            <input className={styles.inpBox} name="name" onChange={handleChange} placeholder="Enter your name"/>
                        </div>
                        <div>
                            <p>Hashnode Username</p>
                            <input className={styles.inpBox} name="username" onChange={handleChange} placeholder="Pick a username"/>
                        </div>
                        <div>
                            <p>Your Email Address</p>
                            <input className={styles.inpBox} name="email" onChange={handleChange} placeholder="Enter your email"/>
                        </div>
                        <div>
                            <p>Password</p>
                            <input className={styles.inpBox} type="password" name="password" onChange={handleChange} placeholder="Enter your password"/>
                        </div>
                    </FormDiv>
                    <div style={{marginTop:"43px"}} className={styles.btnDiv}>
                        <input className={styles.btnSpl} type="submit" value="Signup" />
                        <div style={{display:"flex", alignItems:"center"}}>
                <p>Already have an account?</p>
            <button className={styles.btnSpl} onClick={() => history.push("/login")}>Login</button>
            </div>
            </div>
                </form>
            </Container>
            </div>
    )
}